import { render, staticRenderFns } from "./objection-reporting.vue?vue&type=template&id=2d994e10&scoped=true&lang=pug"
import script from "./objection-reporting.vue?vue&type=script&setup=true&lang=js"
export * from "./objection-reporting.vue?vue&type=script&setup=true&lang=js"
import style0 from "@ui-common/vue-select/dist/vue-select.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d994e10",
  null
  
)

export default component.exports